import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './engineFileInfo.js';
import { RichText, Link } from '@synergycms_core/components/generic';

class EngineFileInfo extends React.Component {
  static displayName = 'EngineFileInfo';

  isMobile = () => {
    return this.props.theme.deviceType === 'MOBIL';
  };

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    return (
      <div className={ theme.computedInnerStyle }>
        {config.hotelInfo && <RichText text={config.hotelInfo} translate={true} ucFirst={true} innerStyle={classes.hotelName} />}
        {config.hotelStars && <RichText text={config.hotelStars} translate={true} ucFirst={true} innerStyle={classes.hotelStars} />}
        {config.hotelInfoDesc && <RichText text={config.hotelInfoDesc} translate={true} ucFirst={true} innerStyle={classes.hotelAddress} />}
        {config.hotelFlyUrl && (
          <Link
            richText={{
              text: '_%¿Quieres añadir un traslado?%_',
              ucFirst: true,
              translate: true
            }}
            innerStyle={classes.flyHotelLink}
            href={config.hotelFlyUrl}
            target={'_blank'}
          />
        )}
      </div>
    );
  }
}

export default compose(
  PropertyManager(['dropDown', 'hotelFlyUrl', 'hotelInfo', 'hotelInfoDesc', 'hotelStars']),
  withThemeJSS({ styleFile, link: true })
)(EngineFileInfo);
